<template> <!-- we can use functional component -->
  <div>
    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h4 v-if="items && items.length">
                Callcenter Agents 1 to {{ items.length }} of {{ items.length }}
              </h4>
            </div>
            <div class="ibox-content">
              <!-- ngIf: :numbers:(numberList.numbers&&!numberList.numbers.length) -->
              <!-- ngIf: options.showProgress -->
              <Loading v-if="loading" />
              <table
                class="table footable table-stripped footable-loaded"
                v-if="!loading"
              >
                <thead>
                  <tr>
                    <th class="col-lg-4">Name</th>
                    <th class="col-lg-4">
                      Telephone Line
                    </th>
                     <th class="col-lg-4">
                      Description
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="gradeX"
                    v-for="user in items"
                    v-bind:key="user.id"
                    data-index="0"
                    style="display: table-row"
                  >
                    <td>
                      <span class="footable-toggle"></span
                      ><!-- ngIf: allow_admin -->
                      <input
                        type="checkbox"
                        v-model="selectedItems"
                        :value="user.id"
                      />&nbsp;
                      <router-link :to="{ path: 'edit/' + user.id }">{{
                        user.name
                      }}</router-link>
                      <!-- <span>{{user.name}}</span> -->
                    </td>
                    <td>{{ user.phone }}</td>
                     <td>{{ user.description }}</td>
                    <!-- <td>
									<strong class="ng-binding">(Administrator)</strong>
								</td> -->
                  </tr>
                  <!-- ngRepeat: number in :numbers:numberList.numbers track by number.number -->
                </tbody>
                <tfoot>
                  <tr v-if="allowAdmin">
                    <td colspan="2">
                      <!-- <button class="btn btn-sm btn-success" ng-click="numberList.newNumber()">New</button> -->
                      <router-link
                        class="btn btn-sm btn-success"
                        :to="{ path: '/create/' }"
                        >Create</router-link
                      >
                      <button
                        class="btn btn-sm btn-danger"
                        @click="deleteItem()"
                        :disabled="selectedItems.length == 0"
                      >
                        Delete
                      </button>
                      <upload-modal
                        :uploadDataPerLine="uploadCsvFilePerLine"
                        :isValidCsvHeaders="isValidCsvHeaders"
						:csvFormat="validCsvHeaders"
                        @uploadfinish="uploadFinish"
                      />
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {CallcenterAgentsService} from "../../services/CallcenterAgentsService";
import Loading from "../../components/Loading";
import UploadModal from "../../components/UploadModal.vue";
export default {
	data: () => ({
		loading: false,
		items: [],
		selectedItems: [],
		allowAdmin: false,
		validCsvHeaders: ["name", "description", "phone"]
	}),
	components: {Loading, UploadModal},
	created() {
		let $injector = this.$root.angularInjector;
		// let rootScope = $injector.get("$rootScope");
		this.allowAdmin = true;
		//   this.allowAdmin = rootScope.allow_admin;
		//   console.info("allowAdmin?", this.allowAdmin);
		//   rootScope.$watch('allowAdmin', (newVal, oldVal) => {
		// 	  console.info("new allowAdmin valu", newVal, oldVal)
		// 	  this.allowAdmin = newVal;
		//   })

		let CoreApiService = $injector.get("CoreApiService");
		this.SwalService = $injector.get("SwalService");

		this.phonesService = $injector.get("PhonesApiService");
		this.callcenterAgentsService = new CallcenterAgentsService(CoreApiService);
	},
	async mounted() {
		this.load();
		// console.info("vue", this.phones)
	},
	methods: {
		async load() {
			this.loading = true;
			this.items = await this.callcenterAgentsService.list();
			this.loading = false;
		},
		async deleteItem() {
			if (this.selectedItems.length == 0) {
				this.SwalService.popup({
					title: "Error",
					type: "warning",
					text: "You must select one or more items to delete"
				});
				return;
			}

			let promises = this.selectedItems.map((id) => {
				return this.callcenterAgentsService.delete(id);
			});
			try {
				await Promise.all(promises);
				this.SwalService.popup({
					title: "Deleted"
				}).then((s) => {
					this.selectedItems = [];
					this.load();
				});
			}
			catch (e) {
				this.SwalService.popup({
					title: e.message || e.statusCode || e,
					type: "error"
				}).then((s) => {
					this.load();
				});
				// let result = await this.callcenterAgentsService.delete(this.selectedItems[0]);
				// if(result && result.responses[0] && result.responses[0].message == "OK") {
			}

			// }
			// else {
			// 	alert("Error", result);
			// }
		},
		async uploadCsvFilePerLine(csvLineObject) {
			const uploadRequests = csvLineObject.map(async(lineObj) => {
				try {
					return await this.callcenterAgentsService.create(lineObj);
				}
				catch (e) {
					return {error: e, message: e.key + " " + lineObj.phone};
				}
			});
			const result = await (await Promise.all(uploadRequests)).filter((promise) => !!promise.error);
			return result;
		},
		isValidCsvHeaders(csvArrayHeaders = []) {
			if (csvArrayHeaders.length !== this.validCsvHeaders.length) {
				return false;
			}
			for (let i = 0; i < this.validCsvHeaders.length; i++) {
				if (this.validCsvHeaders[i] !== csvArrayHeaders[i]) {
					return false;
				}
			}
			return true;
		},
		async uploadFinish(result) {
			await this.load();
		}
	}
};
</script>